import { AgxColumn, AgxRow, AgxLabel } from '@urbanx/agx-ui-components'
import DocumentSection from './DocumentSection'
import { DocumentGroup } from 'services/functions/campaigns/getDocumentsForCampaigns'

interface Props {
  documentsInfo: DocumentGroup[]
  getDocumentTypeLabel: (documentType: string) => string
}

const DocumentsList = (props: Props) => {
  const { documentsInfo, getDocumentTypeLabel } = props

  // filter out any duplicate documents with same documentId
  documentsInfo.forEach((group) => {
    const documentList = new Set()
    const filtered = group.documents.filter((document) => {
      if (documentList.has(document.documentId)) {
        return false
      }
      documentList.add(document.documentId)
      return true
    })

    group.documents = [...filtered]
  })

  return (
    <>
      {documentsInfo &&
        documentsInfo.map((docGroup) => (
          <AgxColumn
            key={docGroup.title}
            extraClasses="panelContainer files-panel"
          >
            <AgxRow extraClasses="panelTitleContainer">
              <AgxLabel medium extraClasses="left-header">
                {docGroup.title}
              </AgxLabel>
              <AgxLabel medium extraClasses="right-header">
                Date Uploaded
              </AgxLabel>
            </AgxRow>
            {docGroup.documents && (
              <DocumentSection
                documents={docGroup.documents}
                getDocumentTypeLabel={getDocumentTypeLabel}
              />
            )}
          </AgxColumn>
        ))}
    </>
  )
}

export default DocumentsList
